<template>
  <div class="g-page">

    <!-- ═══════════════ HEADER ═══════════════ -->
    <div class="header-row">
      <h2 class="page-title">Aksiyalar</h2>
      <div class="header-actions">
        <button class="btn-add-header" @click="openAksiyaForm()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg>
          Yangi aksiya
        </button>
      </div>
    </div>

    <!-- ═══════════════ AKSIYALAR GRID ═══════════════ -->
    <div v-if="loading" class="empty-state">Yuklanmoqda...</div>
    <div v-else-if="aksiyas.length === 0" class="empty-state">
      Hali aksiya yo'q. <button class="link-btn" @click="openAksiyaForm()">Yangisini qo'shing</button>
    </div>

    <div v-else class="aksiya-grid">
      <div v-for="ak in aksiyas" :key="ak.id" class="aksiya-card" :class="{ 'inactive': !ak.is_active }">
        <div class="aksiya-banner">
          <img v-if="ak.image" :src="ak.image" :alt="ak.name" />
          <div v-else class="banner-placeholder">🎁</div>
          <span class="status-pill" :class="ak.is_active ? 'active' : 'inactive'">
            {{ ak.is_active ? 'Faol' : 'O\'chiq' }}
          </span>
        </div>
        <div class="aksiya-body">
          <h3 class="aksiya-name">{{ ak.name }}</h3>
          <div v-if="ak.description" class="aksiya-desc">{{ ak.description }}</div>
          <div class="aksiya-dates" v-if="ak.start_date || ak.end_date">
            📅 {{ fmtDateUnix(ak.start_date) }} — {{ fmtDateUnix(ak.end_date) }}
          </div>
          <div class="aksiya-counter">
            <b>{{ (ak.products || []).length }}</b> ta mahsulot
          </div>
          <div class="aksiya-actions">
            <button class="btn-secondary" @click="openProducts(ak)">
              📦 Mahsulotlar
            </button>
            <button class="btn-icon edit" title="Tahrirlash" @click="openAksiyaForm(ak)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </button>
            <button class="btn-icon del" title="O'chirish" @click="deleteAksiya(ak)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Aksiya CRUD modal -->
    <AksiyaForm v-model="showForm" :edit-item="editAksiya" @saved="fetchAksiyas" />

    <!-- Products inside aksiya -->
    <ProductsModal
      v-if="productsModal.show"
      :aksiya="productsModal.aksiya"
      :ustalar="ustalar"
      @close="productsModal.show = false"
      @refresh="fetchAksiyas"
    />
  </div>
</template>

<script>
import axios from 'axios';
import AksiyaForm from './Form.vue';
import ProductsModal from './ProductsModal.vue';

export default {
  name: 'AksiyalarPage',
  components: { AksiyaForm, ProductsModal },

  data() {
    return {
      loading: false,
      aksiyas: [],
      ustalar: [],
      showForm: false,
      editAksiya: null,
      productsModal: { show: false, aksiya: null },
    };
  },

  mounted() {
    this.fetchAksiyas();
    this.fetchUstalar();
  },

  methods: {
    async fetchAksiyas() {
      this.loading = true;
      try {
        const res = await axios.get('/api/v1/aksiya?with_products=1');
        this.aksiyas = res.data.data || [];
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    async fetchUstalar() {
      try {
        const res = await axios.get('/api/v1/staff/ustalar');
        this.ustalar = res.data.data || [];
      } catch (e) { console.error(e); }
    },

    openAksiyaForm(ak = null) {
      this.editAksiya = ak ? { ...ak } : null;
      this.showForm = true;
    },

    async deleteAksiya(ak) {
      if (!confirm(`"${ak.name}" aksiyasi va uning ${(ak.products || []).length} ta mahsuloti o'chirilsinmi?`)) return;
      try {
        await axios.delete(`/api/v1/aksiya/${ak.id}`);
        this.fetchAksiyas();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      }
    },

    openProducts(ak) {
      this.productsModal = { show: true, aksiya: ak };
    },

    fmtDateUnix(t) {
      if (!t) return '—';
      return new Date(Number(t) * 1000).toLocaleDateString('ru-RU', {
        day: '2-digit', month: '2-digit', year: '2-digit',
      });
    },
  },
};
</script>

<style scoped>
.g-page {
  padding: 28px 32px;
  background: #f8fafc;
  min-height: 100vh;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.page-title { font-size: 28px; font-weight: 900; color: #5850ec; margin: 0; }
.header-actions { display: flex; align-items: center; gap: 12px; }
.btn-add-header {
  display: flex; align-items: center; gap: 7px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border: none;
  height: 40px; padding: 0 20px; border-radius: 12px;
  font-weight: 700; font-size: 13px;
  cursor: pointer; box-shadow: 0 4px 14px rgba(88,80,236,0.3);
  transition: 0.2s;
}
.btn-add-header:hover { opacity: 0.9; }

.empty-state {
  background: white; border-radius: 20px;
  padding: 60px 40px; text-align: center;
  color: #94a3b8; font-weight: 600;
  border: 1px solid #e8edf3;
}
.link-btn { background: none; border: none; color: #5850ec; font-weight: 700; cursor: pointer; text-decoration: underline; }

.aksiya-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 18px;
}
.aksiya-card {
  background: white;
  border-radius: 18px;
  border: 1px solid #e8edf3;
  overflow: hidden;
  transition: 0.2s;
  display: flex;
  flex-direction: column;
}
.aksiya-card:hover { box-shadow: 0 8px 24px rgba(0,0,0,0.08); transform: translateY(-2px); }
.aksiya-card.inactive { opacity: 0.7; }

.aksiya-banner {
  position: relative;
  height: 160px;
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  display: flex; align-items: center; justify-content: center;
}
.aksiya-banner img { width: 100%; height: 100%; object-fit: cover; }
.banner-placeholder { font-size: 60px; }
.status-pill {
  position: absolute; top: 10px; right: 10px;
  padding: 4px 10px; border-radius: 12px;
  font-size: 11px; font-weight: 800;
  text-transform: uppercase;
}
.status-pill.active { background: #dcfce7; color: #166534; }
.status-pill.inactive { background: #fee2e2; color: #991b1b; }

.aksiya-body { padding: 14px 16px 16px; display: flex; flex-direction: column; gap: 8px; flex: 1; }
.aksiya-name { margin: 0; font-size: 16px; font-weight: 800; color: #1e293b; }
.aksiya-desc { font-size: 12px; color: #64748b; line-height: 1.4; }
.aksiya-dates { font-size: 11px; color: #94a3b8; font-weight: 600; }
.aksiya-counter { font-size: 13px; color: #5850ec; }
.aksiya-counter b { font-size: 16px; font-weight: 900; }

.aksiya-actions {
  margin-top: auto;
  display: flex;
  gap: 8px;
  align-items: center;
}
.btn-secondary {
  flex: 1;
  background: #f1f5f9;
  color: #475569;
  border: none;
  border-radius: 10px;
  height: 36px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  transition: 0.15s;
}
.btn-secondary:hover { background: #5850ec; color: white; }

.btn-icon {
  width: 36px; height: 36px;
  border: none; border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: 0.15s;
}
.btn-icon.edit { background: #f5f3ff; color: #5850ec; }
.btn-icon.del  { background: #fff1f2; color: #e11d48; }
.btn-icon:hover { filter: brightness(0.9); transform: scale(1.07); }
</style>
